import { SkeletonLoader } from '@ui/common/components/SkeletonLoader/SkeletonLoader';
import { ArticleVariant } from '@repo/types';

type VideoCardSkeletonProps = {
  variant?: ArticleVariant;
  showTag?: boolean;
  showDate?: boolean;
};

export function VideoCardSkeleton({
  variant = ArticleVariant.Default,
  showTag = true,
  showDate = true,
}: VideoCardSkeletonProps) {
  const isTextSideBySide = variant === ArticleVariant.TextSideBySide;

  return (
    <div
      className={`article-card video-card article-card--skeleton ${isTextSideBySide ? 'article-card--text-side-by-side' : 'article-card--default'}`}
    >
      <div className="article-card__link-wrapper">
        <div className="article-card__media-wrapper">
          <SkeletonLoader height="100%" containerClassName="article-card__skeleton-image" />
        </div>
        <div className="article-card__content">
          <div className="article-card__tag-date-wrapper">
            {showTag && <SkeletonLoader width={60} height={16} />}
            {showDate && <SkeletonLoader width={80} height={16} />}
          </div>
          <SkeletonLoader count={2} height={20} style={{ marginTop: 8 }} />
        </div>
      </div>
    </div>
  );
}
